module.exports = __webpack_public_path__ + "static/production-img-9a3d60d461cbabc37a90ac340b1eb99c.png";